<template>
  <v-form :id="formId" v-model="valid" @submit.prevent="submit">
    <v-jsf v-model="newModel" :schema="schema" :options="options" />
  </v-form>
</template>

<script>
export default {
  props: {
    formId: {
      type: String,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    valid: null,
  }),
  beforeCreate() {
    this.$emit("getFormData")
  },
  methods: {
    submit() {
      const fields = this.schema.properties
      for (let field in fields) {
        if (!this.formData.model[field]) {
          this.formData.model[field] = null
        }
      }
      this.$emit("submitForm")
    },
  },
  computed: {
    newModel: {
      get() {
        return this.formData.model
      },
      set(value) {
        this.formData.model = value
      },
    },
    schema() {
      return this.formData.schema
    },
    options() {
      return this.formData.options
    },
  },
}
</script>

<style lang="scss" scoped></style>
